import { useTranslation } from "react-i18next";
import { sectionHeadingStyle, labelStyle, valueStyle } from "./eventSectionStyles.js";

/**
 * Meeting point, catering, what to bring, accessibility, where the money
 * goes — a definition list, because that is exactly what it is. The
 * labels vary per event, so they come from the content rather than from a
 * fixed set here.
 */
export default function EventGoodToKnow({ items }) {
  const { t } = useTranslation();
  if (!items?.length) return null;

  return (
    <section style={{ display: "flex", flexDirection: "column", gap: "22px" }}>
      <h2 style={sectionHeadingStyle}>{t("events.goodToKnowTitle")}</h2>
      <dl style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(240px, 100%), 1fr))", gap: "0 48px", margin: 0 }}>
        {items.map((item) => (
          <div
            key={item.label}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "5px",
              padding: "18px 0",
              borderBottom: "1px solid rgba(254,250,239,0.1)",
            }}
          >
            <dt style={labelStyle}>{item.label}</dt>
            <dd style={{ ...valueStyle, margin: 0 }}>{item.value}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
